const doRedirect = (url) => {
  window.location = url;
};

export const redirect = {
  doRedirect,
  toRedirectPage() {
    const caasSites = ['preloved', 'whitelabel',
      'midphase', 'onehundredtb', 'thghosting', 'uktwo', 'westhost', 'vpsdotnet'];
    const url = caasSites.includes(window.siteObj.siteCode)
      ? window.siteObj.siteHomePage : `${window.siteObj.siteHomePage}/my.basket`;
    redirect.doRedirect(url);
  },
};
